export const provees = [
	{
		"nombre": "Padrón de Proveedores y Contratistas de la Administración Pública del Estado de Hidalgo",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				//  "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				//  "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
		  "url" : "https://consultapadroncontraloria.hidalgo.gob.mx/"
	},
	
	{
		"nombre": "Sancionados",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				// "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
		//  "url" : "/interes/Prov_contra_sancionados.htm"
		 "url" : "/interes/Sancionados.htm"
		}

];